import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { actionCreators } from '../../store/modules/Branch';
import Image from '../../controls/ImageUpload';
import date from '../../utils/date';
import SaveButton from '../../controls/SaveButton';
import DeleteButton from '../../controls/DeleteButton';
import BackButton from '../../controls/BackButton';

class BranchEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id === 'new' ? null : Number(props.match.params.id),
    };
    this.form = React.createRef();
  }

  componentWillMount() {
    const { id } = this.state;
    const { requestGet } = this.props;

    if (id) {
      requestGet(id);
    }
  }

  handleSave(values) {
    const { id } = this.state;
    const { requestPost, requestPut } = this.props;

    if (id) {
      requestPut(id, JSON.stringify(values));
    } else {
      requestPost(JSON.stringify(values));
    }
  }

  testPhone() {
    return new RegExp('^\\+371[0-9]{8}$').test(this.parent.phone);
  }

  render() {
    const { branch, requestDelete } = this.props;
    const { id } = this.state;

    return (
      <Formik onSubmit={values => this.handleSave(values)}
        ref={this.form}
        enableReinitialize
        validationSchema={Yup.object().shape({
          name: Yup.string().max(200).required(),
          address: Yup.string().max(500).required(),
          latitude: Yup.number()
            .moreThan(-90)
            .lessThan(90)
            .required(),
          longitude: Yup.number()
            .moreThan(-180)
            .lessThan(180)
            .required(),
          phone: Yup.string()
            .min(12)
            .max(12)
            .required()
            .test('valid-phone', 'Nepareizs tālrunis', this.testPhone),
          workingHours: Yup.string().max(500).required(),
          imageId: Yup.string().required(),
        })}
        initialValues={id && branch && branch.id === id ? branch : {
          name: '',
          address: '',
          latitude: '',
          longitude: '',
          phone: '+371',
          workingHours: '',
          imageId: '',
        }}
        render={({ values, errors }) => (
          <Form>
            <div id="dataForm">
              <div className="row m-b-sm">
                <div className="col-md-12">
                  <span className="page-title hex-img">{id ? 'Kafejnīca' : 'Jauna Kafejnīca'}</span>
                  <div className="pageStyle">
                    <BackButton />
                    {id && <DeleteButton onClick={() => requestDelete(id)} />}
                    <SaveButton />
                  </div>
                </div>
              </div>
              <div className="row p-l-md">
                <div className="col-md-12">
                  <div className="panel panel-default hex">
                    <div className="octomask">
                      <div className={errors.imageId ? 'octomask1 error' : 'octomask1'} />
                    </div>
                    <div className="octo">
                      <div className="octo1">
                        <Image imageIds={[values.imageId]} form={this.form}
                          single />
                      </div>
                    </div>
                    <div className="panel-heading" />
                    <div className="panel-body hex" id="scroller">
                      <div className="col-sm-9">
                        <div className="row">
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="name" className="control-label font-bold">
                                Nosaukums (līdz 200 simboliem)
                                <Field id="name"
                                  name="name"
                                  autoFocus
                                  className={errors.name ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="address" className="control-label font-bold">
                                Adrese (līdz 500 simboliem)
                                <Field id="address"
                                  name="address"
                                  autoFocus
                                  className={errors.address ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="phone" className="control-label font-bold">
                                Tālrunis (12 simboli)
                                <Field id="phone"
                                  name="phone"
                                  autoFocus
                                  className={errors.phone ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="latitude" className="control-label font-bold">
                                Koordinātas - platums
                                <Field id="latitude"
                                  name="latitude"
                                  type="number"
                                  autoFocus
                                  className={errors.latitude ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="longitude" className="control-label font-bold">
                                Koordinātas - garums
                                <Field id="longitude"
                                  name="longitude"
                                  type="number"
                                  autoFocus
                                  className={errors.longitude ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="workingHours" className="control-label font-bold">
                                Darba laiks (līdz 500 simboliem)
                                <Field id="workingHours"
                                  name="workingHours"
                                  component="textarea"
                                  rows="4"
                                  className={errors.workingHours ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {id
                        && branch && (
                          <div className="col-sm-3 form-additional-info">
                            <label>
                              Izveidots
                              <div>{date.long(branch.createdOn)}</div>
                            </label>
                          </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )} />
    );
  }
}

BranchEdit.propTypes = {
  branch: PropTypes.shape({ id: PropTypes.number, name: PropTypes.string }),
  requestGet: PropTypes.func.isRequired,
  requestPost: PropTypes.func.isRequired,
  requestPut: PropTypes.func.isRequired,
  requestDelete: PropTypes.func.isRequired,
  match: PropTypes.shape().isRequired,
};

BranchEdit.defaultProps = {
  branch: null,
};

export default connect(
  state => ({
    branch: state.branch.current,
  }),
  dispatch => bindActionCreators(actionCreators, dispatch),
)(BranchEdit);



// WEBPACK FOOTER //
// ./src/components/branch/Edit.jsx